import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 37C83BAE-6330-4E45-A976-3E2642997035
 * name arrow-top-right-thick
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-top-right-thick.svg
 * tags
 * - Arrow 
 */
export const ArrowTopRightThickIcon = createSvgIcon(<><path d="M8.5,18.31L5.69,15.5L12.06,9.12H7.11V5.69H18.31V16.89H14.89V11.94L8.5,18.31Z" /></>, 'ArrowTopRightThickIcon');
export default ArrowTopRightThickIcon